<template>
    <div class="go_tab_panel h100b" :class="active ? 'active_panel' : ''">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "go-panel",
        props: {
            active: {
                type: Boolean,
                default: false
            }
        },
        computed: {},
        methods: {},
        mounted() {
        },
        components: {}
    };
</script>



// WEBPACK FOOTER //
// goingsrc/vueCom/layoutVue/go-panel.vue